<template>
  <div class="box">
    <div class="add_btn">
      <el-button type="primary" @click="addSeckill">新增活动</el-button>
    </div>
    <div>
      <div class="tab_class">
        <div
          class="tab_item"
          @click="tabFn(index)"
          :class="{active:item.checked}"
          v-for=" (item,index) in tabNav"
          :key="index"
        >{{item.name}}</div>
      </div>
      <el-table :data="list" border style="width: 100%">
        <el-table-column type="index" align="center" label="编号" width="180"></el-table-column>
        <el-table-column prop="activityName" align="center" label="活动名称"></el-table-column>
        <el-table-column prop="time" align="center" label="活动时间"></el-table-column>
        <el-table-column prop="statusSize" align="center" label="状态"></el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope" v-if="scope.row.activityStatus != 1">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">重新发布</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @current-change="pageFn()"
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          :page-size="10"
          :total="activityCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getSeckillList, delSeckill } from "@/api/goods";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      tabNav: [
        {
          name: "所有秒杀",
          checked: true,
          status: -1,
          // statusSize:
          page: 1,
        },
        {
          name: "未开始",
          checked: false,
          status: 0,
          page: 1,
        },
        {
          name: "进行中",
          checked: false,
          status: 1,
          page: 1,
        },
        {
          name: "已结束",
          checked: false,
          status: 2,
          page: 1,
        },
      ],
      list: [],
      index: 0,
      activityCount: 10,
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters(["chooseCompany", "companyList", "mchId"]),
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      let navItem = this.tabNav[this.index];
      let mchId = this.chooseCompany.id;
      let data = {
        status: navItem.status,
        page: this.currentPage,
        pageCount: 10,
        mchId:mchId
      };
      getSeckillList(data).then((res) => {
        this.list = res.data.activityList;
        this.activityCount = res.data.activityCount.activityCount;
        this.list.forEach((item) => {
          item.time = that.rebuildTime(item.starTime);
          item.time = item.time + " - ";
          item.time = item.time + that.rebuildTime(item.endTime);
          if (item.activityStatus == 0) {
            item.statusSize = "未开始";
          } else if (item.activityStatus == 1) {
            item.statusSize = "进行中";
          } else if (item.activityStatus == 2) {
            item.statusSize = "已结束";
          }
        });
      });
    },
    rebuildTime: function (time) {
      const now = new Date().getTime();
      const date = new Date(Number(time)),
        Y = date.getFullYear(),
        M =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1,
        D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(),
        h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
        m =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      const dateTimestamp = date.getTime();
      return String(M).concat(".", D, " ", h, ":", m);
    },
    tabFn(index) {
      this.currentPage = 1;
      for (let i = 0; i < this.tabNav.length; i++) {
        this.tabNav[i].checked = false;
      }
      this.tabNav[index].checked = true;
      this.index = index;
      this.getData();
    },
    addSeckill() {
      this.$router.push({ path: "/main/seckill/addSeckill" });
      // this.$router.push({
      //   path: "/main/seckill/addSeckill"
      // });
    },
    pageFn() {
      this.getData();
    },
    handleEdit(index, item) {
      console.log(item.activityId);
      if (item.statys != 1) {
        this.$router.push({
          path: `/main/seckill/addSeckill`,
          query: { id: item.activityId },
        });
      }
    },
    handleDelete(index, item) {
      delSeckill(item.activityId).then((res) => {
        if (res.code == 1) {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getData();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.add_btn {
  padding: 20px 0;
}
.tab_class {
  display: flex;

  .tab_item {
    width: 100px;
    height: 40px;
    text-align: center;
    line-height: 50px;
    background-color: #fff;
    border: 1px solid #fff;
    cursor: pointer;
  }
  .active {
    background-color: #fff;
    color: #409eff;
    border: 1px solid #409eff;
    border-bottom: 1px solid #fff;
    border-radius: 10px 10px 0 0;
  }
}
.block {
  width: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/seckill/seckillList.vue